import React from "react"

import { Input } from "@coval/ui"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { CHAT_WEBSOCKET_TOOLTIPS } from "./tooltips"
import type { ChatWebSocketFieldProps } from "./types"

export const ChatWebSocketHandshakeFields: React.FC<
  ChatWebSocketFieldProps
> = ({ metadata, onMetadataUpdate, disabled = false }) => {
  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">Handshake</h4>

      <div className="space-y-2">
        <FieldLabel
          htmlFor="chat-ws-ready-message-type"
          tooltip={CHAT_WEBSOCKET_TOOLTIPS.readyMessageType}
        >
          Ready Message Type
        </FieldLabel>
        <Input
          id="chat-ws-ready-message-type"
          aria-label="Ready Message Type"
          placeholder="session_ready"
          value={metadata.handshake_ready_message_type || ""}
          onChange={(e) =>
            onMetadataUpdate({
              handshake_ready_message_type: e.target.value,
            })
          }
          disabled={disabled}
        />
        <p className="text-xs text-coval-text-muted">
          Message type indicating the session is ready. Leave empty to start
          immediately (default: no handshake wait).
        </p>
      </div>

      <div className="space-y-2">
        <FieldLabel
          htmlFor="chat-ws-handshake-timeout"
          tooltip={CHAT_WEBSOCKET_TOOLTIPS.handshakeTimeout}
        >
          Handshake Timeout (seconds)
        </FieldLabel>
        <Input
          id="chat-ws-handshake-timeout"
          aria-label="Handshake Timeout"
          type="number"
          placeholder="30"
          min={1}
          value={
            metadata.handshake_timeout_seconds != null
              ? String(metadata.handshake_timeout_seconds)
              : ""
          }
          onChange={(e) => {
            const raw = e.target.value
            if (raw === "") {
              onMetadataUpdate({
                handshake_timeout_seconds: undefined,
              })
            } else {
              const trimmed = raw.trim()
              if (/^\d+$/.test(trimmed)) {
                const parsed = Number(trimmed)
                if (parsed > 0) {
                  onMetadataUpdate({
                    handshake_timeout_seconds: parsed,
                  })
                }
              }
            }
          }}
          disabled={disabled}
        />
        <p className="text-xs text-coval-text-muted">
          Seconds to wait for the handshake to complete (default: 30)
        </p>
      </div>
    </div>
  )
}
